import React from 'react'
import Select from '../Select/Select'
import styles from './Filters.module.css'

const FILTER_TYPES = [
  { key: 'upcoming', label: 'Upcoming' },
  { key: 'historical', label: 'Historical' },
]

const TIME_PERIODS = [
  { key: '1', label: 'One day' },
  { key: '7', label: 'One week' },
  { key: '30', label: 'One month' },
  { key: '180', label: 'Six months' },
  { key: '360', label: 'One year' },
  // { key: '1080', label: 'Three years' },
  // { key: '1800', label: 'Five years' },
]

const MARKET_CAPS = [
  { key: 'all', label: 'All' },
  { key: '10000000000-', label: 'Large (more than $10B)' },
  { key: '2000000000-10000000000', label: 'Medium ($2B-$10B)' },
  { key: '0-2000000000', label: 'Small (less than $2B)' },
]

interface Props {
  type?: string|string[],
  timePeriod?: string|string[],
  marketCap?: string|string[],
  onChange: (filter: 'type' | 'timePeriod' | 'marketCap', key: string) => void,
}

export default function Filters({ type, timePeriod, marketCap, onChange }: Props) {
  function selectType(newType: string) {
    onChange('type', newType)
  }

  function selectTimePeriod(newTimePeriod: string) {
    onChange('timePeriod', newTimePeriod)
  }

  function selectMarketCap(newMarketCap: string) {
    onChange('marketCap', newMarketCap)
  }

  return (
    <div className={styles.wrapper}>
      <div>
        <Select label='Type' options={FILTER_TYPES} selectedKey={type} onSelect={selectType} />
      </div>
      <div>
        <Select label='Time period' options={TIME_PERIODS} selectedKey={timePeriod} onSelect={selectTimePeriod} />
      </div>
      <div>
        <Select label='Market cap' options={MARKET_CAPS} selectedKey={marketCap} onSelect={selectMarketCap} />
      </div>
    </div>
  )
}